'use es6';

import PropTypes from 'prop-types';
import { createRef, Component } from 'react';
import I18n from 'I18n';
import { toolbarI18nKey } from '../../constants/toolbar';
import MoreMenuContent from './MoreMenuContent';
import StyleProtectedUIDropdown from '../style-protected/StyleProtectedUIDropdown';
import withDisabledContext from '../hoc/withDisabledContext';
import { jsx as _jsx } from "react/jsx-runtime";
class MoreMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialRenderComplete: false
    };
    this.ref = /*#__PURE__*/createRef();
  }
  componentDidMount() {
    const {
      updateControlRect
    } = this.props;
    const {
      width
    } = this.ref.current.getBoundingClientRect();
    updateControlRect({
      width
    });
    this.setState({
      initialRenderComplete: true
    });
  }
  render() {
    const {
      className,
      dropdownClassName,
      onOpenComplete,
      disabled,
      toolbarWidth,
      menuItems,
      updateControlRect,
      controlRects,
      contextualNodeAttributes
    } = this.props;
    if (this.state.initialRenderComplete && !menuItems.length) {
      return null;
    }
    return /*#__PURE__*/_jsx(StyleProtectedUIDropdown, {
      use: "unstyled",
      buttonText: I18n.text(toolbarI18nKey('moreMenu')),
      buttonUse: "transparent",
      buttonClassName: className,
      closeOnMenuClick: false,
      dropdownClassName: dropdownClassName,
      autoPlacement: "horiz",
      placement: "bottom left",
      minMenuWidth: 0,
      animateOnToggle: false,
      onOpenComplete: onOpenComplete,
      disabled: disabled,
      buttonRef: this.ref,
      children: /*#__PURE__*/_jsx(MoreMenuContent, {
        toolbarWidth: toolbarWidth,
        menuItems: menuItems,
        updateControlRect: updateControlRect,
        controlRects: controlRects,
        contextualNodeAttributes: contextualNodeAttributes
      })
    });
  }
}
MoreMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  toolbarWidth: PropTypes.number.isRequired,
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  onOpenComplete: PropTypes.func,
  disabled: PropTypes.bool,
  updateControlRect: PropTypes.func.isRequired,
  controlRects: PropTypes.object,
  contextualNodeAttributes: PropTypes.object
};
export default withDisabledContext(MoreMenu);